import { render, staticRenderFns } from "./NewRequestForm.vue?vue&type=template&id=529543e5&scoped=true"
import script from "./NewRequestForm.vue?vue&type=script&lang=js"
export * from "./NewRequestForm.vue?vue&type=script&lang=js"
import style0 from "./NewRequestForm.vue?vue&type=style&index=0&id=529543e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529543e5",
  null
  
)

export default component.exports